import { render, staticRenderFns } from "./DropdownField.vue?vue&type=template&id=63f3cf95&"
import script from "./DropdownField.vue?vue&type=script&lang=js&"
export * from "./DropdownField.vue?vue&type=script&lang=js&"
import style0 from "./DropdownField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports